import BaseAccountController from '../../lib/controllers/BaseAccountController';

declare var LtFramework: lt.Static;

export default class ResendAccountActivationEmailController extends BaseAccountController {
	public static $inject: string[] = ['$scope', 'UserResource', 'UserIdentityResource'];

	public account: MyAccountApi.IUserIdentity;
	public accountDetail: MyAccountApi.IUserAccountDetail;
	public resendActivate: MyAccountApi.IResendActivation;

	public generalError: string;
	public verified = false;
	public username: string;
	public password: string;
	public loading = true;
	public updated = false;
	public newEmpty = '';
	public confirmEmpty = '';
	public newEmailErrorMessage: string;
	public confirmationErrorMessage: string;
	public newUserErrorMessage: string;

	private readonly UserIdentity: MyAccountApi.IUserIdentityResource;

	constructor($scope: ng.IScope, User: MyAccountApi.IUserResource, UserIdentityResource: MyAccountApi.IUserIdentityResource) {
		super($scope);

		this.UserIdentity = UserIdentityResource;
	}

	public userValidate(username: string, password: string): void {
		if (!this.newUserErrorMessage) {
			this.accountDetail.username = username;
			this.accountDetail.password = password;
			this.username = username;
			this.password = password;

			this.UserIdentity.validate(this.accountDetail, (account: MyAccountApi.IUserIdentity) => {
				this.verified = true;
				this.account = account;
				this.loading = false;
			}, (failure: MyAccountApi.IServiceFailureResponse) => {
				this.loading = false;
				this.generalError = failure.data.validationErrors[0].message;
			});
		}
	}

	public updateEmail(newEmail: string, updateEmail: string): void {
		this.updated = false;
		if (newEmail == null && updateEmail == null) {
			this.resendActivate = {
				newEmail: '',
				confirmEmail: '',
				user: this.accountDetail
			};

			this.UserIdentity.save(this.resendActivate, (account: MyAccountApi.IUserIdentity) => {
				this.account = account;
				this.updated = true;
			}, (failure: MyAccountApi.IServiceFailureResponse) => {
				this.loading = false;
				this.newEmailErrorMessage = failure.data.validationErrors[0].message;
			});
		} else {
			this.validateNewEmail(newEmail);
			this.validateConfirmation(newEmail, updateEmail);
			if (!this.newEmailErrorMessage && !this.confirmationErrorMessage) {
				this.resendActivate.newEmail = newEmail;
				this.resendActivate.confirmEmail = updateEmail;
				this.resendActivate.user = this.accountDetail;

				this.UserIdentity.save(this.resendActivate, (account: MyAccountApi.IUserIdentity) => {
					this.account = account;
					this.updated = true;
				}, (failure: MyAccountApi.IServiceFailureResponse) => {
					this.loading = false;
					this.generalError = failure.data.validationErrors[0].message;
				});
			}
		}
	}

	public validateNewEmail(newEmail: string): void {
		this.newEmailErrorMessage = this.performValidation(newEmail);
	}

	public validateConfirmation(newEmail: string, newEmailConfirmation: string): void {
		if (newEmail !== newEmailConfirmation) {
			this.confirmationErrorMessage = 'Sorry, the email addresses entered don’t match.';
		} else {
			this.confirmationErrorMessage = '';
		}
	}

	private performValidation(emailAddress: string): string {
		const genericMessage = 'Sorry, that seems to be an invalid email format.';
		const splitEmail = emailAddress.split('@');
		if (splitEmail.length !== 2) {
			return genericMessage;
		}

		const startWithError = /^(\.|www\.|https?)/.test(emailAddress);
		if (startWithError) {
			return genericMessage;
		}

		const localPart = splitEmail[0];
		const domainPart = splitEmail[1];
		const domainSplit = domainPart.split('.');

		if (localPart.length >= 65) {
			return 'Your new email address must be 140 characters or less.';
		}
		const tld = domainSplit[domainSplit.length - 1];

		if (domainSplit.length < 2) {
			return genericMessage;
		} else if (domainSplit.length === 2 && !domainSplit[0]) {
			return genericMessage;
		} else if (domainSplit.length >= 2) {
			let isError = false;
			domainSplit.forEach((dom: string) => {
				if (/^\-/.test(dom) || /\-$/.test(dom)) {
					isError = true;
				}
			});

			if (isError) {
				return genericMessage;
			}
		}

		if (tld.length < 2 || tld.length > 7) {
			return genericMessage;
		}

		if (emailAddress.length > 140) {
			return 'Your new email address must be 140 characters or less.';
		}

		if (/[^0-9a-zA-Z-.]/.test(splitEmail[1])) {
			return genericMessage;
		}

		if (/[^!#$%&'*/=-?^_{|}~.0-9a-zA-Z-\\]/.test(localPart)) {
			return genericMessage;
		}

		return '';
	}
}
